import React, { FunctionComponent, useMemo } from 'react';
import { ArticleCategoryFragmentResponse } from '../../fragments/article-category';
import BreadcrumbsComponent from '../Breadcrumbs';

export type BreadcrumbsProps = {
  title?: string;
  category?: ArticleCategoryFragmentResponse;
};

const Breadcrumbs: FunctionComponent<BreadcrumbsProps> = (props) => {
  const { category, title } = props;
  const { universe } = category || {};

  const items = useMemo(() => {
    const links = [
      { label: universe?.parent_universe?.title, to: universe?.parent_universe?.root_page?.slug?.current },
      { label: universe?.title, to: universe?.root_page?.slug?.current },
      { label: category?.title, to: category?.slug?.current },
      { label: title },
    ];

    return links.filter((link) => !!link.label);
  }, [title, category, universe]);

  return <BreadcrumbsComponent items={items} margin={[0, 0, 3]} />;
};

export default Breadcrumbs;
